import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import sessionStorageEngine from "redux-persist/lib/storage/session";

import siteReducer from "./features/siteSlice";
import drawerReducer from "./features/drawerSlice";
import menuReducer from "./features/roleWiseMenuSlice";
import alertReducer from "./features/alertSlice";
import authReducer from "./features/authSlice";
import secondaryMenuReducer from "./features/secondaryMenuSlice";
import DateTime from "../reducers/dateTime.reducer";

/* --------------------------------
   Persist config for secondaryMenu only (sessionStorage)
--------------------------------- */
const secondaryPersistConfig = {
  key: "secondaryMenu",
  storage: sessionStorageEngine,
};

const persistedSecondaryMenu = persistReducer(
  secondaryPersistConfig,
  secondaryMenuReducer,
);
/* --------------------------------
   Combine reducers
--------------------------------- */
const appReducer = combineReducers({
  site: siteReducer,
  drawer: drawerReducer,
  menu: menuReducer,
  alert: alertReducer,
  auth: authReducer,
  secondaryMenu: persistedSecondaryMenu,
  DateTime,
});

/* --------------------------------
   Root reducer
--------------------------------- */

const rootReducer = (state, action) => {
  if (action.type === "RESET_APP") {
    state = undefined;
  }
  return appReducer(state, action);
};

/* --------------------------------
   Redux Persist configuration
--------------------------------- */

const persistConfig = {
  key: "root",
  storage,
  // whitelist: ["menu", "auth", "secondaryMenu", "DateTime"], //persist only needed data
  whitelist: ["menu", "auth", "DateTime"], //persist only needed data
};

/* --------------------------------
   Persisted reducer
--------------------------------- */

const persistedReducer = persistReducer(
    persistConfig,
    rootReducer
);

/* --------------------------------
   Store
--------------------------------- */

export const store = configureStore({
  reducer: persistedReducer,

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

/* --------------------------------
   Persistor
--------------------------------- */

export const persistor = persistStore(store);
